import styled from "@emotion/styled";
import {
  Box,
  Button,
  Input,
  Stack,
  Typography,
  CircularProgress,
  FormControlLabel,
  Switch,
  Card,
  CardContent,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Stepper from "../../../Common/Stepper";
import { COMPLETE, NEXT, HORIZONTAL } from "../../../constants/Constants";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SalesOrderItems from "../../../components/SalesOrder/SalesOrderItems";
import SalesSummeryCustomer from "../../../components/SalesOrderCustomer/SalesSummeryCustomer";
import ItemSummeryCustomer from "../../../components/SalesOrderCustomer/ItemSummeryCustomer";
import { useParams, Link, useNavigate } from "react-router-dom";
import SuccessModal from "../../../Common/Modals/SuccessModal";
import FailedModal from "../../../Common/Modals/FailedModal";
import AlertToast from "../../../components/common/Toast";
import { apiConstants } from "../../../constants";
import { authHeader, getUserToken } from "../../../helpers";
import ProgressCircularWithBackdrop from "../../../Common/ProgressCircular/ProgressCircularWithBackdrop";
import Intro from "../../atoms/Intro/Intro.component";
import { getCurrentUser } from "../../../helpers";
import QuantityChangeConfirmDialog from "../../../components/SalesOrder/QuantityChangeConfirmDialog";
import useQuantityChangeConfirmation from "../../../hooks/useQuantityChangeConfirmation";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import * as XLSX from 'xlsx';

const StyledContainer = styled(Box)({
  width: "100%",
  minWidth: "500px",
  border: "1px dashed #C4C4C4",
  height: "379px",
});

const StyledStepperContainer = styled(Stack)({
  width: "200px",
  borderRight: "1px solid #C4C4C4",
  minHeight: "500px",
});

const StyledTableContainer = styled(Stack)({
  marginTop: "10px",
});

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.neutral.light,
  height: "60px",
}));

const StyledImage = styled("img")({
  display: "block",
  maxHeight: "200px",
  maxWidth: "100%",
  objectFit: "contain",
  paddingLeft: "10px",
});

function AdminAcceptSalesOrder() {
  const [sizes, setSizes] = useState([]);
  const [data, setData] = useState({
    items: [],
  });
  const [steps, setSteps] = useState([COMPLETE]);
  const [activeStep, setActiveStep] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [isSuccess, setIssuccess] = useState(false);
  const [success, setSuccess] = useState("");
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(true);
  const [totalDelivery, setTotalDelivery] = useState(0);
  const [openProgressCircular, setOpenProgressCircular] = useState(false);
  const [disabledSubmitBtn, setDisabledSubmitBtn] = useState(false);
  const [orderItemsError, setOrderItemsError] = useState({
    status: false,
    message: "",
    index: 0,
  });

  const [enableCustomizeNameNumber, setEnableCustomizeNameNumber] = useState(false);
  const [itemDetailsFile, setItemDetailsFile] = useState(null);
  const [itemDetailsFileUrl, setItemDetailsFileUrl] = useState("");
  const [itemDetailsFilePath, setItemDetailsFilePath] = useState("");
  const [previewLoading, setPreviewLoading] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const {
    showConfirmDialog,
    pendingChanges,
    totals,
    requestConfirmation,
    handleConfirm,
    handleCancel,
    prepareItemsWithConfirmation,
  } = useQuantityChangeConfirmation();

  const [originalQuantities, setOriginalQuantities] = useState({});

  const currentUserData = getCurrentUser();
  const currentUserId = currentUserData?.id;

  let { id } = useParams();
  const navigate = useNavigate();

  const [toastState, setToastState] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const [toastMessage, setToastMessage] = useState("");
  const handleToastClose = () =>
    setToastState({ open: false, vertical: "top", horizontal: "right" });

  const getItem = useCallback(() => {
    const requestOptions = {
      method: "GET",
      headers: authHeader(),
    };

    fetch(`${apiConstants.API_URL}/sales-orders/${id}`, requestOptions).then(
      (response) => {
        response.text().then((text) => {
          const resData = text && JSON.parse(text);
          setTotalDelivery(resData?.data?.estimated_shipping_charges);

          if (resData?.data?.item_details_file_path) {
            setItemDetailsFilePath(resData?.data?.item_details_file_path);
            setItemDetailsFileUrl(resData?.data?.item_details_file_url);
            setEnableCustomizeNameNumber(true);
          }

          fetch(`${apiConstants.API_URL}/sizes`, requestOptions).then(
            (response) => {
              response.text().then((text) => {
                const sizesRes = text && JSON.parse(text);
                setSizes(sizesRes?.data);
                const sizesArray = sizesRes?.data;
                if (resData?.data.comment) {
                  setComments(resData?.data.comment);
                }

                const origQtys = {};
                resData?.data.items.forEach((item, index) => {
                  origQtys[index] = item.qty;
                });
                setOriginalQuantities(origQtys);

                const newDataItems = resData?.data.items.map((item) => {
                  let arrangedItems = [];
                  let itemDetailsWithQuantityArrangedItems = [];

                  if (
                    item?.item_details.length !== 0 &&
                    item?.flag_name_no === 1
                  ) {
                    item?.item_details.forEach((q) => {
                      sizesArray?.forEach((s) => {
                        if (q.size?.id === s.id) {
                          const obj = {
                            ...q,
                            size_id: q.size?.id,
                            selectedSize: { id: s.id, name: s.name },
                          };
                          arrangedItems.push(obj);
                        }
                      });
                    });
                    itemDetailsWithQuantityArrangedItems = [
                      {
                        size_id: 0,
                        quantity: "",
                        selectedSize: { id: 0, name: "" },
                      },
                    ];
                  } else if (
                    item?.item_details.length !== 0 &&
                    item?.flag_name_no === 0
                  ) {
                    let sizeWithQuantity = [];
                    item?.item_details.forEach((q) => {
                      sizesArray?.forEach((s) => {
                        if (q.size?.id === s.id) {
                          const obj = {
                            size_id: q.size?.id,
                            quantity: 1,
                            selectedSize: { id: s.id, name: s.name },
                          };
                          sizeWithQuantity.push(obj);
                        }
                      });
                    });

                    let hash = Object.create(null);
                    let result = [];

                    sizeWithQuantity.forEach(function (o) {
                      if (!hash[o.size_id]) {
                        hash[o.size_id] = {
                          size_id: o.size_id,
                          quantity: 0,
                          selectedSize: o.selectedSize,
                        };
                        result.push(hash[o.size_id]);
                      }
                      hash[o.size_id].quantity += +o.quantity;
                    });
                    itemDetailsWithQuantityArrangedItems = result;

                    for (let i = 0; i < item?.qty; i++) {
                      let newObt = {
                        number: "",
                        name: "",
                        size_id: 0,
                        id: "",
                        selectedSize: { id: 0, name: "" },
                      };
                      arrangedItems.push(newObt);
                    }
                  } else if (item?.item_details.length === 0) {
                    for (let i = 0; i < item?.qty; i++) {
                      let newObt = {
                        number: "",
                        name: "",
                        size_id: 0,
                        id: "",
                        selectedSize: { id: 0, name: "" },
                      };
                      arrangedItems.push(newObt);
                    }
                    itemDetailsWithQuantityArrangedItems = [
                      {
                        size_id: 0,
                        quantity: "",
                        selectedSize: { id: 0, name: "" },
                      },
                    ];
                  }

                  let newOb = {
                    ...item,
                    price_id: item?.price?.id,
                    color_id: item?.color?.id,
                    item_details: arrangedItems,
                    itemDetailsWithQuantity:
                      itemDetailsWithQuantityArrangedItems,
                    item_details_file_path:
                      item?.item_details_file_path === null
                        ? ""
                        : item?.item_details_file_path,
                    item_details_file_url:
                      item?.item_details_file_url === null
                        ? ""
                        : item?.item_details_file_url,
                    originalQtyOnLoad: item.qty,
                    original_unit_price_on_load: item.original_unit_price || item.unit_price,
                    original_total_price_on_load: item.original_total_price || item.total_price,
                  };
                  return newOb;
                });

                const newDataObject = {
                  ...resData?.data,
                  items: newDataItems,
                };

                setData(newDataObject);

                const itemSteps = resData?.data?.items.map(
                  (item) => `${item?.style} (${item?.price?.item?.name })`
                );
                setSteps([...itemSteps, COMPLETE]);
              });
            }
          );
        });
      }
    );
  }, [id]);

  const displayData = data?.items[activeStep] ?? {};

  const isReviewStep =
    data.items && data.items.length > 0 && activeStep === data.items.length;

  const title = isReviewStep ? "Review Order" : `${displayData?.style} (${displayData?.price?.item?.name })`;
  const image = !isReviewStep ? displayData?.image_url : "";
  const image2 = !isReviewStep ? displayData?.image_2_url : "";
  const image3 = !isReviewStep ? displayData?.image_3_url : "";
  const buttonText = isReviewStep ? "CONFIRM SALES ORDER" : NEXT;

  useEffect(() => {
    if (!mounted) {
      setMounted(true);
      getItem();
    }
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, [getItem, mounted]);

  // Load existing file preview when sales order has item_details_file_path
  useEffect(() => {
    if (itemDetailsFileUrl && isExcelFile(itemDetailsFilePath)) {
      // Fetch and parse the Excel file from the server using the URL
      fetch(itemDetailsFileUrl)
        .then(response => response.arrayBuffer())
        .then(buffer => {
          try {
            const data = new Uint8Array(buffer);
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            setExcelData(jsonData);
          } catch (error) {
            console.error('Error parsing existing Excel file:', error);
          }
        })
        .catch(error => {
          console.error('Error fetching Excel file:', error);
        });
    }
  }, [itemDetailsFilePath, itemDetailsFileUrl]);

  const hasQuantityChanges = useMemo(() => {
    if (!data?.items) return false;
    return data.items.some((item) => {
      const originalQty = item.originalQtyOnLoad;
      const currentQty = item.qty;
      return originalQty !== undefined && originalQty !== currentQty;
    });
  }, [data?.items]);

  const handleItemDetailsFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPreviewLoading(true);
      setItemDetailsFile(file);
      const fileUrl = URL.createObjectURL(file);
      setItemDetailsFileUrl(fileUrl);
      
      // Parse Excel file if it's an Excel file
      if (isExcelFile(file.name)) {
        parseExcelFile(file);
      } else {
        setExcelData(null);
        setTimeout(() => setPreviewLoading(false), 500);
      }
    }
  };

  const handleRemoveItemDetailsFile = () => {
    setItemDetailsFile(null);
    setItemDetailsFileUrl("");
    setItemDetailsFilePath("");
    setExcelData(null);
  };

  const uploadItemDetailsFile = async () => {
    if (!itemDetailsFile) {
      return itemDetailsFilePath || "";
    }

    const token = getUserToken();

    // Create FormData and append the file with field name 'file'
    const formData = new FormData();
    formData.append('file', itemDetailsFile);
    formData.append('category', 'sales-order');

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        // Don't set Content-Type - browser will set it with boundary
      },
      body: formData,
    };

    try {
      const response = await fetch(
        `${apiConstants.API_URL}/file/sales-order`,
        requestOptions
      );
      const text = await response.text();
      const data = text && JSON.parse(text);

      if (!response.ok) {
        throw new Error(data?.error || "Failed to upload file");
      }

      return data?.data?.path || "";
    } catch (error) {
      console.error("Error uploading item details file:", error);
      throw error;
    }
  };

  const prepareItemsForSubmission = (items, confirmedChanges = null) => {
    return items?.map((item, index) => {
      let newObt;

      const hasConfirmedChange = confirmedChanges?.find((c) => c.index === index);

      if (item?.flag_name_no) {
        const formateArray = item?.item_details.map((c) => {
          return {
            number: c.number,
            name: c.name,
            size_id: c.size_id,
            id: c.id ? c.id : "",
          };
        });

        newObt = {
          ...item,
          item_details: formateArray,
        };
      } else {
        let array = [];
        item?.itemDetailsWithQuantity?.forEach((q) => {
          for (let i = 0; i < q.quantity; i++) {
            const obj = {
              number: "",
              name: "",
              size_id: q.size_id,
              id: q.id ? q.id : "",
            };
            array.push(obj);
          }
        });
        newObt = {
          ...item,
          item_details: array,
        };
      }

      if (hasConfirmedChange) {
        newObt.qty_change_confirmed = true;
        newObt.original_qty = hasConfirmedChange.originalQty;
        newObt.original_order_data = hasConfirmedChange.originalData;
      }

      const extraChargesList = item?.sales_order_item_extra_charges?.map((x) => {
        return {
          id: x.id,
          qty: x.qty,          
          reference: x.reference ?? '',
          cost: x.cost,
          extra_charge_id: x.extra_charge.id,
          sales_order_item_id: x.sales_order_item_id
        };
      });
      newObt.sales_order_item_extra_charges = extraChargesList;
      delete newObt.itemDetailsWithQuantity;
      if (newObt?.item_details_file_path === "") {
        delete newObt.item_details_file_path;
        delete newObt.item_details_file_url;
      }

      return newObt;
    });
  };

  const submitSalesOrderWithItems = async (preparedItems) => {
    const {
      order_method,
      organization,
      quotation,
      status,
      estimated_shipping_charges,
    } = data;

    if (status.id === 2) {
      setToastMessage("Order is already accepted");
      setToastState({
        open: true,
        vertical: "top",
        horizontal: "right",
      });
      setOpenProgressCircular(false);
      return;
    }

    try {
      let uploadedItemDetailsPath = "";
      if (enableCustomizeNameNumber) {
        uploadedItemDetailsPath = await uploadItemDetailsFile();
      }

      const reqObe = {
        order_method_id: order_method?.id,
        invoice_id: null,
        organization_id: organization?.id,
        quotation_id: quotation?.id,
        status_id: 2,
        comment: comments,
        items: preparedItems,
        estimated_shipping_charges: estimated_shipping_charges,
        sales_agent_id: currentUserId,
        item_details_file_path: uploadedItemDetailsPath,
      };

      const requestOptions = {
        method: "PUT",
        headers: authHeader(),
        body: JSON.stringify(reqObe),
      };

      fetch(`${apiConstants.API_URL}/sales-orders/${id}`, requestOptions).then(
        (response) => {
          response.text().then((text) => {
            const res = text && JSON.parse(text);
            if (!response.ok) {
              if (response.status === 401) {
              }
              const error = (res && res.error) || response.statusText;
              const errorMessage = Object.values(error).map(
                (errorKey) => errorKey[0]
              );
              setOpenProgressCircular(false);
              setToastMessage(errorMessage);
              setToastState({
                open: true,
                vertical: "top",
                horizontal: "right",
              });
            } else {
              setOpenProgressCircular(false);
              setSuccess(res?.data?.id);
              setIssuccess(true);
              setActiveStep(steps.length);
              setDisabledSubmitBtn(true);
            }
          });
        }
      );
    } catch (error) {
      setOpenProgressCircular(false);
      setToastMessage(error.message || "Failed to upload file");
      setToastState({
        open: true,
        vertical: "top",
        horizontal: "right",
      });
    }
  };

  const submitAction = () => {
    setOpenProgressCircular(true);

    const needsConfirmation = requestConfirmation(data.items, (confirmedChanges) => {
      const preparedItems = prepareItemsForSubmission(data.items, confirmedChanges);
      submitSalesOrderWithItems(preparedItems);
    });

    if (!needsConfirmation) {
      const preparedItems = prepareItemsForSubmission(data.items);
      submitSalesOrderWithItems(preparedItems);
    } else {
      setOpenProgressCircular(false);
    }
  };

  const onDialogConfirm = () => {
    setOpenProgressCircular(true);
    handleConfirm();
  };

  const handleCloseSuccessModal = () => {
    setIssuccess(true);
    navigate(`/admin/sales-orders`);
  };

  const nextAction = () => {
    if (!isReviewStep) {
      setActiveStep(activeStep + 1);
    } else {
      submitAction();
    }
  };

  const preAction = () => {
    setActiveStep(activeStep - 1);
  };

  const updateComments = (e) => {
    const { target } = e;
    setComments(target?.value);
  };

  const getFileExtension = (filename) => {
    return filename?.split('.').pop()?.toLowerCase() || '';
  };

  const isImageFile = (filename) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    return imageExtensions.includes(getFileExtension(filename));
  };

  const isPdfFile = (filename) => {
    return getFileExtension(filename) === 'pdf';
  };

  const isExcelFile = (filename) => {
    const excelExtensions = ['xlsx', 'xls', 'csv'];
    return excelExtensions.includes(getFileExtension(filename));
  };

  const parseExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        
        // Get first sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        // Convert to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
        setExcelData(jsonData);
        setPreviewLoading(false);
      } catch (error) {
        console.error('Error parsing Excel file:', error);
        setExcelData(null);
        setPreviewLoading(false);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  let breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" to="/admin/quotations">
      All Quotations
    </Link>,
    <Typography key="3">{"View Quotation"}</Typography>,
  ];

  return (
    <>
      <Stack direction="column" spacing={5}>
        <Intro
          pageTitle={`Accept Sales Order`}
          pageTitleShort={"Accept Sales Order"}
          breadcrumbs={breadcrumbs}
          additionalWidgets=""
          sx={{ margin: "50px 0" }}
        />
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          >
            <CircularProgress size={50} />
          </Box>
        ) : (
          <Stack direction="column" spacing={5}>
            <Box>
              <Stepper
                activeStep={activeStep}
                orientation={HORIZONTAL}
                steps={steps}
                alternativeLabel={false}
              />
            </Box>
            <Stack direction="row" spacing={5}>
              <Stack style={{ textAlign: "left" }} spacing={4}>
                <Typography fontSize="28px" fontWeight={500}>
                  {title}
                </Typography>
                {!isReviewStep ? (
                  <>
                    <StyledContainer
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        flexWrap: "nowrap",
                        overflowX: "auto",
                      }}
                    >
                      {!image ? <div></div> : <StyledImage src={image} />}
                      {!image2 ? <div></div> : <StyledImage src={image2} />}
                      {!image3 ? <div></div> : <StyledImage src={image3} />}
                    </StyledContainer>
                    <StyledTableContainer spacing={4}>
                      <SalesOrderItems
                        sizes={sizes}
                        item_details={displayData?.item_details}
                        displayData={displayData}
                        setData={setData}
                        data={data}
                        activeStep={activeStep}
                        editStatus={true}
                        error={orderItemsError}
                        setError={setOrderItemsError}
                        setDisabledSubmitBtn={setDisabledSubmitBtn}
                        hideFileUpload={true}
                      />
                      <Stack>
                        <Typography
                          style={{ fontSize: "20px", fontWeight: 700 }}
                        >
                          Comments
                        </Typography>
                        <Typography style={{ fontSize: "15px" }}>
                          Please specify if you have any additional request,
                          special instructions or changes, etc.
                        </Typography>
                        <Stack style={{ marginTop: "20px" }} spacing={4}>
                          <Typography style={{ fontSize: "15px" }}>
                            Your Comments
                          </Typography>
                          <Input value={comments} onChange={updateComments} />
                        </Stack>
                      </Stack>
                    </StyledTableContainer>
                  </>
                ) : (
                  <Box sx={{ padding: "1rem" }}>
                    <Card sx={{ mb: 3 }}>
                      <CardContent>
                        <Typography variant="h6" gutterBottom>
                          Customize Name and Number
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          If you need to add custom names and numbers to this order, enable this option and upload your file.
                        </Typography>
                        
                        <FormControlLabel
                          control={
                            <Switch
                              checked={enableCustomizeNameNumber}
                              onChange={(e) => setEnableCustomizeNameNumber(e.target.checked)}
                              color="primary"
                            />
                          }
                          label="Enable Customize Name and Number"
                        />

                        {enableCustomizeNameNumber && (
                          <Box sx={{ mt: 2 }}>
                            <Stack spacing={2}>
                              <Box>
                                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                                  Template File:
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: "block" }}>
                                  Please download the template file and fill in the details.
                                </Typography>
                                <Button
                                  variant="outlined"
                                  href="/downloads/Sales Order Numbers and Names Template.xlsx"
                                  sx={{ mb: 2 }}
                                >
                                  Download Template
                                </Button>
                              </Box>
                              
                              <Box>
                                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                                  Upload File:
                                </Typography>
                                {!itemDetailsFileUrl && !itemDetailsFilePath ? (
                                  <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<CloudUploadIcon />}
                                  >
                                    Upload Name/Number File
                                    <input
                                      type="file"
                                      hidden
                                      accept=".xlsx,.xls,.csv,.pdf"
                                      onChange={handleItemDetailsFileUpload}
                                    />
                                  </Button>
                                ) : (
                                  <>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        p: 2,
                                        border: "1px solid #e0e0e0",
                                        borderRadius: 1,
                                      }}
                                    >
                                      <InsertDriveFileIcon color="primary" />
                                      <Typography sx={{ flex: 1 }}>
                                        {itemDetailsFile?.name || itemDetailsFilePath?.split("/").pop()}
                                      </Typography>
                                      <Button
                                        size="small"
                                        color="error"
                                        startIcon={<DeleteIcon />}
                                        onClick={handleRemoveItemDetailsFile}
                                      >
                                        Remove
                                      </Button>
                                    </Box>
                                    
                                    {/* File Preview */}
                                    {previewLoading ? (
                                      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                                        <CircularProgress size={30} />
                                      </Box>
                                    ) : (
                                      <Box sx={{ mt: 2, border: "1px solid #e0e0e0", borderRadius: 1, p: 2 }}>
                                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                                          Preview:
                                        </Typography>
                                        {isImageFile(itemDetailsFile?.name || itemDetailsFilePath) ? (
                                          <img
                                            src={itemDetailsFileUrl}
                                            alt="File preview"
                                            style={{
                                              maxWidth: "100%",
                                              maxHeight: "400px",
                                              objectFit: "contain",
                                              display: "block",
                                            }}
                                          />
                                        ) : isExcelFile(itemDetailsFile?.name || itemDetailsFilePath) ? (
                                          <Box sx={{ overflowX: "auto", maxHeight: "400px", overflowY: "auto" }}>
                                            {excelData && excelData.length > 0 ? (
                                              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                <tbody>
                                                  {excelData.map((row, rowIndex) => (
                                                    <tr key={rowIndex} style={{ backgroundColor: rowIndex === 0 ? "#f5f5f5" : "white" }}>
                                                      {row.map((cell, cellIndex) => (
                                                        <td
                                                          key={cellIndex}
                                                          style={{
                                                            border: "1px solid #ddd",
                                                            padding: "8px",
                                                            fontWeight: rowIndex === 0 ? "bold" : "normal",
                                                          }}
                                                        >
                                                          {cell !== null && cell !== undefined ? String(cell) : ""}
                                                        </td>
                                                      ))}
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                            ) : (
                                              <Typography variant="body2" color="text.secondary">
                                                No data to preview
                                              </Typography>
                                            )}
                                          </Box>
                                        ) : isPdfFile(itemDetailsFile?.name || itemDetailsFilePath) ? (
                                          <Box>
                                            <iframe
                                              src={itemDetailsFileUrl}
                                              style={{
                                                width: "100%",
                                                height: "400px",
                                                border: "none",
                                              }}
                                              title="PDF Preview"
                                            />
                                          </Box>
                                        ) : (
                                          <Box sx={{ textAlign: "center", py: 3 }}>
                                            <InsertDriveFileIcon sx={{ fontSize: 60, color: "text.secondary" }} />
                                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                              Preview not available for this file type
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                              {itemDetailsFile?.name || itemDetailsFilePath?.split("/").pop()}
                                            </Typography>
                                          </Box>
                                        )}
                                      </Box>
                                    )}
                                  </>
                                )}
                                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
                                  Accepted formats: .xlsx, .xls, .csv, .pdf
                                </Typography>
                              </Box>
                            </Stack>
                          </Box>
                        )}
                      </CardContent>
                    </Card>

                    <Box sx={{ border: "1px solid #C4C4C4", p: 2 }}>
                      <Typography variant="h6">
                        Please review your order details on the right side.
                      </Typography>
                      <Typography variant="body2">
                        If everything looks correct, click the "CONFIRM SALES
                        ORDER" button.
                      </Typography>
                      {hasQuantityChanges && (
                        <Typography 
                          sx={{ 
                            fontSize: "14px", 
                            color: "#ff9800",
                            marginTop: "10px",
                            fontWeight: 500,
                          }}
                        >
                          ⚠️ You have made quantity changes. You will be asked to confirm these changes before submitting.
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
              </Stack>

              <Stack spacing={2}>
                <Box style={{ marginTop: "70px" }}>
                  {!isReviewStep && displayData && (
                    <ItemSummeryCustomer
                      {...displayData}
                      originalQty={displayData?.originalQtyOnLoad}
                      shippingEnabled={data?.organization?.shipping_enabled ?? true}
                    />
                  )}
                </Box>

                {!(data?.organization?.shipping_enabled ?? true) && (
                  <Typography
                    fontSize={"13px"}
                    sx={{ fontStyle: "italic", opacity: 0.7 }}
                  >
                    Shipping is disabled for this organization.
                  </Typography>
                )}

                <SalesSummeryCustomer
                  data={data}
                  displayData={displayData}
                  activeStep={activeStep}
                  totalDelivery={totalDelivery}
                />

                <StyledButton
                  variant="contained"
                  color="success"
                  endIcon={<ArrowForwardIcon />}
                  onClick={nextAction}
                  disabled={disabledSubmitBtn}
                >
                  {buttonText}
                </StyledButton>
                {activeStep > 0 && (
                  <Button startIcon={<ArrowBackIcon />} onClick={preAction}>
                    BACK
                  </Button>
                )}
              </Stack>
            </Stack>

            <QuantityChangeConfirmDialog
              open={showConfirmDialog}
              onClose={handleCancel}
              onConfirm={onDialogConfirm}
              changes={pendingChanges}
              totals={totals}
            />

            <ProgressCircularWithBackdrop open={openProgressCircular} />
            <SuccessModal
              title={"Sales Order Accepted Successfully!"}
              open={isSuccess}
              handleClose={handleCloseSuccessModal}
              body={`Sales Order #${success} is accepted successfully. Your account manager will contact and guide you through the next steps`}
              extra="Thank you for your order."
            />
            <FailedModal />
            <AlertToast
              toastMessage={toastMessage}
              toastState={toastState}
              handleClose={handleToastClose}
            />
          </Stack>
        )}
      </Stack>
    </>
  );
}

export default AdminAcceptSalesOrder;
